import { useContext } from "react"
import AuthContext from "store/context/PublicContext"
import { AppContext } from "store/context/AppContext"
import useCancelToken from "hooks/useCancelToken"
import OMNIX_MODULE from "constants/OMNIX_MODULE"
import Swal from "sweetalert2"
import { get_module_entity_action_middleware } from "services/middleware_services"
import useAuthorizer from "overrides/theme/entel/base/hooks/useAuthorizer"

const useCombinedScheduleBFF = () => {
  const { newCancelToken, isCancel } = useCancelToken()
  const { logout_user_action } = useAuthorizer()
  const {
    user: { token },
  } = useContext(AuthContext)
  const { loading_app, set_loading_app } = useContext(AppContext)

  
  const get_schedule_types_action = async (_endpoint: string) => {
    try {
      const res = await get_module_entity_action_middleware(
        OMNIX_MODULE.COMBINED,
        `schedules/types`,
        null,
        token,
        newCancelToken(),
      )
      return res.data.message
    } catch (error: any) {
      if (isCancel(error)) return
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message,
        icon: "error",
      })
      if ([401].includes(error?.response?.status)) return logout_user_action()
    }
  }

  return {
    get_schedule_types_action,
    loading_app,
    set_loading_app,
  }
}

export default useCombinedScheduleBFF

